<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="novaListaAquisicaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Gerar Processo de Aquisição</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="nova_aq">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    sizing="sm"
                                    label="Unidade"
                                    type="select"
                                    placeholder="Selecione..."
                                    :optionsList="$store.state.unidade.unidade_operacaos"
                                    optionsData="id_unidade_operacao"
                                    required
                                    :validate="validate"
                                    v-model="nova_aq.id_unidade_operacao">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Finalização do Processo"
                                    type="date"
                                    v-model="nova_aq.dt_fim_processo" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observação"
                                    v-model="nova_aq.st_observacao" />
                            </div>
                        </div>
                        <p class="alert alert-info mt-3">
                            {{ nova_aq.items.length }} {{ nova_aq.items.length == 1 ? 'item selecionado' : 'itens selecioandos' }}
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_aquisicao()">Gerar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';


export default {
    data() { 
        return { 
            nova_aq: null, 
            validate: false, 
        }
    },

    components: { 
        AzInput,
        AzSubmit, 
    },

    methods: { 
        incluir_aquisicao(lista, parms = {}) {
            this.nova_aq = null;
            this.validate = false;

            this.$nextTick(() => {
                this.nova_aq = {
                    id_aquisicao: null,
                    st_tipo: 'M',
                    id_unidade_operacao: "",
                    id_estoque_grupo_local: parms.id_estoque_grupo_local 
                        ? parms.id_estoque_grupo_local 
                        : ( parms.id_estoque_local ? -1 : null ),
                    id_estoque_local: parms.id_estoque_local, 
                    dt_fim_processo: "",
                    fl_ativo: true,
                    items: lista.map(item => {
                        const fator = item.in_fator_conversao ? item.in_fator_conversao : 1;

                        let qtde = item.qtde_compra 
                            ? item.qtde_compra 
                            : ( parseInt(_.get(item, 'item_parm.in_estoque_ideal', 0))
                                - parseInt(_.get(item, 'saldo.qtd'), 0) );


                        return {
                            fl_ativo: true,
                            st_tipo: 'M',
                            id_estoque_item: item.id_estoque_item,
                            st_unidade: ( fator > 1 && item.st_unidade_compra ) ? item.st_unidade_compra : item.st_unidade_estoque,
                            dc_quantidade: Math.round(qtde / fator),
                            in_fator: fator,
                        };
                    }),
                    fornecedores: [],
                };

                $('#novaListaAquisicaoModal').modal('show');
            });
        },

        salvar_aquisicao () {
            this.$util.atualizar(this, {
                service: 'aquisicao',
                dados: this.nova_aq,
                modal: 'novaListaAquisicaoModal',
                toast: true,
            });
        },
    }
}
</script>
